// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPriceTypeFilterSchema {
  /** UI значение для фильтра (Н-р: За квартиру) **/
  name: string;
  /** Возможные значения фильтра **/
  value: EValue;
}

export enum EValue {
  /** Цена за объект **/
  'Price' = 'price',
  /** Цена за м² **/
  'PriceSqm' = 'priceSqm',
}
